import styled from "styled-components";

export const CheckMark = styled.span`
    display: inline-flex;
    position: relative;
    min-height: 18px;
    flex-shrink: 0;
    [type="checkbox"]:checked,
    [type="checkbox"]:not(:checked) {
        position: absolute;
        left: -9999px;
        opacity: 0;
    }
  [type="checkbox"]:checked + label,
  [type="checkbox"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-flex;
  }
  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #9b9b9b;
    border-radius: 2px;
    background: #fff;
  }
  [type="checkbox"]:checked + label:before {
    border: 1px solid #008cff;
    content: "";
    width: 18px;
    height: 18px;
    background: #008cff;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 2px;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="checkbox"]:checked + label:after {
    position: absolute;
    left: 6px;
    top: 3px;
    content: "";
    display: block;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
`;